import keycloakAxios from '@/services/axios';
import {removeGroup, updateGroupInRedux} from '@/redux-store/slices/groups';
import {store} from '@/redux-store/store';
import {emitGroupChangeEvent} from './change-observable';
import {GroupData} from '@/types/group';

export const leaveGroup = async (groupId: string) => {
  const response = await keycloakAxios.get(`group/leave/${groupId}`);

  if (response.status >= 300) {
    throw new Error(
      `Error leaving the group: Invalid status code: ${response.status}`
    );
  }

  emitGroupChangeEvent({
    type: 'change',
    data: response.data as GroupData
  });

  store.dispatch(updateGroupInRedux(response.data));
  store.dispatch(removeGroup(groupId));

  return response.data;
};
